import { ComponentProps } from 'react'

export type DialogContentProps = ComponentProps<'div'>

export default function DialogContent({
  children,
  className,
  ...props
}: DialogContentProps) {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  )
}
